import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { exchangeSession } from "../lib/api";
import { useAuth } from "../lib/auth";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [error, setError] = useState("");
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/admin/login");
      return;
    }
    const session_id = m[1];

    exchangeSession(session_id)
      .then((u) => {
        setUser(u);
        window.history.replaceState({}, "", "/admin");
        navigate("/admin", { state: { user: u } });
      })
      .catch(() => {
        setError("Authentication failed. Please try again.");
        setTimeout(() => navigate("/admin/login"), 2000);
      });
  }, [navigate, setUser]);

  return (
    <div data-testid="auth-callback" className="min-h-screen flex items-center justify-center bg-[#050505]">
      <div className="text-center">
        <p className="overline mb-4">Signing you in</p>
        <div className="w-12 h-12 border-2 border-gold/30 border-t-gold rounded-full animate-spin mx-auto mb-6" />
        {error && <p className="text-red-400 text-sm">{error}</p>}
      </div>
    </div>
  );
}
